export default __webpack_public_path__ + "static/media/intro3.82893719.png";